









































import Vue from 'vue';
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import {
  FormValidation,
} from '@/mixins';
import { ExtendMixins } from '@/services';
import { RegistrationIdentityFormModel, StepperSteps } from '@/@types/member';

export default ExtendMixins(
  FormValidation,
).extend({
  name: 'RegisterStep1',
  props: {
    formModel: {
      type: Object as () => RegistrationIdentityFormModel,
      required: true,
    },
    step: {
      type: Object as () => StepperSteps,
      required: true,
    },
    brand: {
      type: String,
      required: true,
    },
  },
  validations: {
    formModel: {
      saId: {
        required,
      },
    },
  },
  computed: {
    saIdErrors(): string[] {
      const formField = 'formModel.saId';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'register-step-1-SAID-error-required',
            'global_form-error_selectaccount-id_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
      ]);
    },
    brandPhone(): string {
      return this.$options.filters.t(`register-page-help-phone-${this.brand}`) ;
    },
  },
  methods: {
    submit(): void {
      this.$emit('submitRegistrationAccountID');
    },
    sanitizeSAID(): void {
      this.formModel.saId = this.formModel.saId.replace(/[^0-9]/g, '');
    },
  },
});
